import { marked } from 'marked'

// eslint-disable-next-line import/prefer-default-export
export const parseMarkdown = (string: string) => {
	// See: https://marked.js.org/using_advanced#options
	marked.setOptions({
		gfm: true,
		breaks: true
	})

	return marked.parse(string)
}
